<template>
    <div class="price-container">
        <!-- nodisclosureDes not equal to null hour ， Forced to price add mosaic ( only for Pocket listing of listings ) -->
        <template v-if="!showSoldPrice && !showListingPrice">
            <no-disclosure :des="cmpNondisclosureDes"></no-disclosure>
        </template>
        <template v-else-if="showSoldPrice && showListingPrice">
            <span class="first-price">{{
                $ft.formatCurrency({ value: info.soldPrice, noSpace:true, currencySymbol})
            }}</span>
            <span class="second-price">{{
                $ft.formatCurrency({ value: info.price, noSpace:true, currencySymbol })
            }}</span>
            <span
                v-if="trend"
                class="trend"
                :class="{
                    up: info.soldPrice > info.price,
                    down: info.soldPrice < info.price
                }"
            >
                <span class="iconfont icon-trend-up"></span>
                <span class="iconfont icon-trend-down"></span>
                {{ trend }}
            </span>
        </template>
        <template v-else>
            <div class="first-price">
                {{
                    $ft.formatCurrency({
                        value: showSoldPrice ? info.soldPrice : info.price,
                        noSpace: true,
                        currencySymbol
                    })
                }}
            </div>
        </template>
    </div>
</template>
<script>
import price from "../_mixins/price"
export default {
    mixins: [price]
}
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';

.md-sold-detail.broker.pc .price-container {
    position: relative;
    .nodisclosure {
        .dollar {
            @include color-theme();
            font-size: 24px;
        }
        .secret {
            font-size: 12px;
            @include color-theme();
        }
        .des {
            font-size: 12px;
            color: #ff5661;
        }
    }
    display: inline-flex;
    align-items: flex-end;
    .first-price {
        font-size: 28px;
        font-family: var(--font-bold);
        color: var(--color-title);
        display: inline-block;
    }
    .second-price {
        font-size: 16px;
        color: #a8a8a8;
        display: inline-block;
        text-decoration: line-through;
        margin-left: 8px;
    }
    .trend {
        font-size: 16px;
        font-family: var(--font-bold);
        margin-left: 5px;
        .icon-trend-up,
        .icon-trend-down {
            display: none;
            font-size: 12px;
        }
        &.up {
            color: #29cb97;
            .icon-trend-up {
                display: inline;
            }
        }
        &.down {
            color: #fb4444;
            .icon-trend-down {
                display: inline;
            }
        }
    }
}
</style>
